import React, { createContext, useContext, useMemo } from 'react'
import { Capability } from './generated/capabilities'

// The active role's granted capabilities, provided once near the top of the tree so any
// component can gate a control without prop-drilling. The backend @requires(...) is the
// real boundary; this only hides what a role can't use.
const CapabilitiesContext = createContext<ReadonlySet<Capability>>(new Set())

export function CapabilitiesProvider({ capabilities, children }: {
    capabilities: readonly Capability[],
    children: React.ReactNode,
}) {
    const set = useMemo(() => new Set(capabilities), [capabilities])
    return <CapabilitiesContext.Provider value={set}>{children}</CapabilitiesContext.Provider>
}

export function useHasCapability(capability: Capability): boolean {
    return useContext(CapabilitiesContext).has(capability)
}
